module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// ./~/contra/~/atoa/atoa.js
// module id = 1341
// module chunks = 1